import React from "react";

import { RelatorioVendasPage } from "@/features/relatorio-vendas";

// Página magra: o relatório inteiro mora em features/relatorio-vendas/ desde
// 21/09/2026 (antes eram 1.331 linhas aqui). `defaultTab` vem da rota do menu.
export default function RelatorioVendas({ defaultTab } = {}) {
  return <RelatorioVendasPage defaultTab={defaultTab} />;
}
